const Note = (props) => (
  <svg fill='none' height={21} width={20} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M16.667 7.374V15.5c0 2.5-1.491 3.334-3.333 3.334H6.667c-1.841 0-3.333-.834-3.333-3.334V7.374c0-2.708 1.492-3.333 3.333-3.333 0 .517.209.983.55 1.325.342.342.809.55 1.325.55h2.917a1.878 1.878 0 0 0 1.875-1.875c1.842 0 3.333.625 3.333 3.333Z'
      fill='currentColor'
      opacity={0.4}
    />
    <path
      d='M13.333 4.041a1.878 1.878 0 0 1-1.875 1.875H8.54c-.517 0-.983-.208-1.325-.55a1.864 1.864 0 0 1-.55-1.325c0-1.033.842-1.875 1.875-1.875h2.917c.516 0 .983.208 1.325.55.341.342.55.808.55 1.325ZM10 11.959H6.665a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h3.333a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625ZM13.333 15.291H6.666a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h6.667a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Z'
      fill='currentColor'
    />
  </svg>
);
export default Note;
